<template>
    <span>
        {{ time(value) }}
    </span>
</template>

<script>
import Column from '@mixins/Column';

export default {
    mixins: [ Column ],
    methods: {

        time(value){
			 if ( typeof value == 'string' && value.trim() != '' ) {
                let date = new Date(value);

            if ( isNaN(date.getTime()) === false ) {
                    return  date.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' });
                }
            }

		},

    }
}
</script>
